import React, { useEffect, useState } from 'react';
import { Form } from 'antd';

import * as recurrence from '../../../../constants/recurrence-constants';

import HourlyGroup from '../recurrence-groups/hourly-group';
import DailyGroup from '../recurrence-groups/daily-group';
import WeeklyGroup from '../recurrence-groups/weekly-group';
import MonthlyGroup from '../recurrence-groups/monthly-group';
import YearlyGroup from '../recurrence-groups/yearly-group';

const FrequencyContainer = ({ form, selectedFrequency, rootContainer }) => {
  const [frequency, setFrequency] = useState(null);
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [isRadioGroup, setIsRadioGroup] = useState(false);
  const [requiredItems, setRequiredItems] = useState([]);

  const frequencyRelatedItems = ['interval', 'byDay', 'byMonth', 'byMonthDay', 'bySetPosition'];

  useEffect(() => {
    setFrequency(selectedFrequency);

    const choiceVal = form.getFieldValue(['rules', 'choice']);

    switch (selectedFrequency) {
      case recurrence.FREQUENCY_TYPES.Hourly:
      case recurrence.FREQUENCY_TYPES.Daily:
      case recurrence.FREQUENCY_TYPES.Weekly:
        setIsRadioGroup(false);
        setRequiredItems(['interval']);
        form.setFieldValue(['rules', 'interval'], 1);
        if (choiceVal) {
          form.setFieldValue(['rules', 'choice'], null);
          setSelectedChoice(null);
        }
        break;
      case recurrence.FREQUENCY_TYPES.Monthly:
        setIsRadioGroup(true);
        setRequiredItems([]);
        if (choiceVal) {
          form.setFieldValue(['rules', 'choice'], choiceVal);
          setSelectedChoice(choiceVal);
        }
        break;
      case recurrence.FREQUENCY_TYPES.Yearly:
        setIsRadioGroup(true);
        setRequiredItems([]);
        if (choiceVal) {
          form.setFieldValue(['rules', 'choice'], choiceVal);
          setSelectedChoice(choiceVal);
        }
        break;
    }
  }, [selectedFrequency]);

  const onChangeChoice = (value) => {
    setSelectedChoice(value);

    if (value) {
      const choiceFormNames = value.split('_');

      _.forEach(_.filter(frequencyRelatedItems, (f) => !choiceFormNames.includes(f)) || [], (obj) => {
        if (!choiceFormNames.includes(obj)) {
          form.setFieldValue(['rules', `${obj}`], obj === 'interval' ? 1 : []);
        }
      });
    }

    if (isRadioGroup) {
      setIsRadioGroup(true);
    } else {
      setIsRadioGroup(false);
    }
  };

  return (
    <Form.Item wrapperCol={{ offset: 0, span: 24 }} shouldUpdate={true}>
      {() => {
        switch (frequency) {
          case recurrence.FREQUENCY_TYPES.Hourly:
            return (
              <HourlyGroup onChangeGroup={onChangeChoice} requiredItems={requiredItems} selectedChoice={selectedChoice} isRadioGroup={isRadioGroup} />
            );

          case recurrence.FREQUENCY_TYPES.Daily:
            return (
              <DailyGroup
                onChangeGroup={onChangeChoice}
                requiredItems={requiredItems}
                selectedChoice={selectedChoice}
                isRadioGroup={isRadioGroup}
                rootContainer={rootContainer}
              />
            );

          case recurrence.FREQUENCY_TYPES.Weekly:
            return (
              <WeeklyGroup
                onChangeGroup={onChangeChoice}
                requiredItems={requiredItems}
                selectedChoice={selectedChoice}
                isRadioGroup={isRadioGroup}
                rootContainer={rootContainer}
              />
            );

          case recurrence.FREQUENCY_TYPES.Monthly:
            return (
              <MonthlyGroup
                onChangeGroup={onChangeChoice}
                requiredItems={requiredItems}
                selectedChoice={selectedChoice}
                isRadioGroup={isRadioGroup}
                rootContainer={rootContainer}
              />
            );
          case recurrence.FREQUENCY_TYPES.Yearly:
            return (
              <YearlyGroup
                onChangeGroup={onChangeChoice}
                requiredItems={requiredItems}
                selectedChoice={selectedChoice}
                isRadioGroup={isRadioGroup}
                rootContainer={rootContainer}
              />
            );
          default:
            return null;
        }
      }}
    </Form.Item>
  );
};

export default FrequencyContainer;
